import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Mental} from "../Mental";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {MentalHelper} from "../utils/MentalHelper";

export class RandomFeatureBuy extends PIXI.Container implements StageLayer {
    private _background: PIXI.Graphics;
    private _fullBackground: PIXI.Graphics;
    private _allFeatureLayout: PIXI.Sprite[] = [];
    private _fireFrameBlast: TimelineSprite;
    private _fireFrameLoop: TimelineSprite;
    private _toggleFire: PIXI.Sprite;
    private _animTl: TimelineLite;

    constructor() {
        super();
        this.initAnimation();
        this.position.set(146, 150);
    }

    public playAnimation(index: number): TimelineLite {

        this.hidePresentation();

        this._animTl = new TimelineLite({
            paused: true,
            onStart: () => {
                [this._background, this._fullBackground, this._allFeatureLayout[0], this._allFeatureLayout[1], this._allFeatureLayout[2]].forEach(value => {
                    value.visible = true;
                    value.alpha = 0;
                });
                this._fireFrameLoop.position.set((this._allFeatureLayout[index].position.x) - 10, (this._allFeatureLayout[index].position.y) - 20);
                this._fireFrameBlast.position.set((this._allFeatureLayout[index].position.x) - 10, (this._allFeatureLayout[index].position.y) - 20);
                this._toggleFire.visible = true;
                this._toggleFire.alpha = 0;

                this._fireFrameLoop.alpha = 1;
            },
            onComplete: () => {
                this._toggleFire.visible = false;

                this._fireFrameLoop.hide();
                this._fireFrameBlast.hide();

                [this._background, this._fullBackground, this._allFeatureLayout[0], this._allFeatureLayout[1], this._allFeatureLayout[2]].forEach(value => {
                    value.visible = false;
                    value.tint = 0xffffff;
                });

            }
        });

        this._animTl.to([this._background, this._fullBackground, this._allFeatureLayout[0], this._allFeatureLayout[1], this._allFeatureLayout[2]], {
            duration: 0.5,
            alpha: 1
        });

        const randomPos: number[] = [index]; // to toggle randomly

        for (let i: number = 0; i < 3; i++) {
            let generatedNumber: number = MentalHelper.getRandomIntInRange(0, 2);
            if (randomPos.length) {
                while (generatedNumber === randomPos[0]) {
                    generatedNumber = MentalHelper.getRandomIntInRange(0, 2);
                }
                randomPos.unshift(generatedNumber);
            }
        }

        for (let i: number = 0; i < randomPos.length; i++) {
            this._animTl.add(() => {
                this._toggleFire.position.set(this._allFeatureLayout[randomPos[i]].position.x - 5, this._allFeatureLayout[randomPos[i]].position.y);
            });
            this._animTl.fromTo(this._toggleFire, {alpha: 1}, {
                duration: 0.25,
                alpha: 0
            });
        }

        this._animTl.add(() => {
            for (let i = 0; i < this._allFeatureLayout.length; i++) {
                if (i !== index) {
                    this._allFeatureLayout[i].tint = 0x555555;
                }
            }
        });

        this._animTl.add(this._fireFrameBlast.getAnimationAutoShowHide(true, true));
        this._animTl.add(this._fireFrameLoop.getAnimationAutoShowHide(true, false));

        this._animTl.to(this._fireFrameLoop, {alpha: 0, duration: 0.25});

        this._animTl.to({}, {duration: 1});

        this._animTl.to([this._background, this._fullBackground, this._allFeatureLayout[0], this._allFeatureLayout[1], this._allFeatureLayout[2]], {
            alpha: 0,
            duration: 0.25
        });

        return this._animTl.play(0);
    }

    public hidePresentation() {
        if (this._animTl) {
            this._animTl.totalProgress(1);
            this._animTl.clear();
        }
    }

    private initAnimation(): void {
        // background
        this._background = new PIXI.Graphics();
        this._background.beginFill(0x000000, 0.65);
        this._background.drawRect(0, 0, 144 * 3, 450);
        this._background.endFill();
        this._background.visible = false;

        this._fullBackground = new PIXI.Graphics();
        this._fullBackground.beginFill(0x000000, 0.65);
        this._fullBackground.drawRect(-480, -480, 1680, 1680);
        this._fullBackground.endFill();
        this._fullBackground.visible = false;

        // featureLayout
        const autopsy: PIXI.Sprite = new PIXI.Sprite(Mental.assetLoader.getTextures("randomBonusAutopsy")[0]);
        const lobotomy: PIXI.Sprite = new PIXI.Sprite(Mental.assetLoader.getTextures("randomBonusLobotomy")[0]);
        const mental: PIXI.Sprite = new PIXI.Sprite(Mental.assetLoader.getTextures("randomBonusMental")[0]);

        autopsy.anchor.set(0.5);
        lobotomy.anchor.set(0.5);
        mental.anchor.set(0.5);

        autopsy.position.set(autopsy.width / 2, autopsy.height / 2);
        lobotomy.position.set((lobotomy.width / 2) + autopsy.width, lobotomy.height / 2);
        mental.position.set(mental.width / 2 + autopsy.width / 2, mental.height / 2 + autopsy.height);

        this._allFeatureLayout.push(autopsy, lobotomy, mental);

        this.addChild(this._fullBackground, this._background);

        this._allFeatureLayout.forEach((sprite: PIXI.Sprite, index: number) => {
            switch (index) {
                case 0:
                    sprite.position.x += 45;
                    sprite.position.y += 25;
                    break;
                case 1:
                    sprite.position.x += 65;
                    sprite.position.y += 25;

                    break;
                default :
                    sprite.position.x += 55;
                    sprite.position.y += 50;
                    break;
            }
            sprite.visible = false;
            this.addChild(sprite);
        });

        this._fireFrameBlast = new TimelineSprite(Mental.assetLoader.getTextures("fireFrameStart"));
        this._fireFrameBlast.anchor.set(0.5);
        this._fireFrameBlast.hide();
        this._fireFrameBlast.scale.set(2.1);
        this._fireFrameBlast.blendMode = PIXI.BLEND_MODES.ADD;
        this._fireFrameBlast.position.set((this._allFeatureLayout[0].position.x) - 10, (this._allFeatureLayout[0].position.y) - 20);

        this._fireFrameLoop = new TimelineSprite(Mental.assetLoader.getTextures("fireFrameLoop"));
        this._fireFrameLoop.anchor.set(0.5);
        this._fireFrameLoop.hide();
        this._fireFrameLoop.scale.set(2.1);
        this._fireFrameLoop.blendMode = PIXI.BLEND_MODES.ADD;
        this._fireFrameLoop.position.set((this._allFeatureLayout[0].position.x) - 10, (this._allFeatureLayout[0].position.y) - 20);

        this._toggleFire = new PIXI.Sprite(Mental.assetLoader.getTextures("toggleFrames")[0]);
        this._toggleFire.anchor.set(0.5);
        this._toggleFire.visible = false;
        this._toggleFire.scale.set(2.4, 2.2);
        this._toggleFire.blendMode = PIXI.BLEND_MODES.ADD;
        this._toggleFire.tint = 0xffc600
        this._toggleFire.position.set((this._allFeatureLayout[0].position.x) - 5, (this._allFeatureLayout[0].position.y));

        this.addChild(this._fireFrameLoop, this._fireFrameBlast, this._toggleFire);
    }
}